import { Business, Delete, Edit, House } from "@mui/icons-material";
import {
  Card,
  CardActions,
  CardContent,
  Divider,
  IconButton,
  Radio,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import DeleteAddressConfirmDialog from "dialogs/DeleteAddressConfirmDialog";
import EditAddressDialog from "dialogs/EditAddressDialog";
import { Colors } from "helpers/Consts";
import { useState } from "react";
import { useMutationEditAddress } from "services/api/mutations/useMutationEditAddress";
import { useMutationRemoveAddress } from "services/api/mutations/useMutationRemoveAddress";
import { IUserAddressInfo } from "types/Address";
import { UseQueryResult } from "react-query";
import { IShoppingBagData } from "../../types/ShoppingBag";

type Props = {
  singleItem: IUserAddressInfo;
  shoppingBagQuery: UseQueryResult<IShoppingBagData>
};

function SingleAddressCard({ singleItem, shoppingBagQuery }: Props) {
  const { mutate: updateAddress } = useMutationEditAddress();
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);
  const [openEditAddressDialog, setOpenEditAddressDialog] = useState<boolean>(false);
  const handleClickUpdate = () => {
    // console.log("update " + singleItem.complete_address);
    if (singleItem.active) {
      // singleItem.active = false;
    } else {
      singleItem.active = true;

      const request = {...singleItem, current_shopping_bag_id: shoppingBagQuery.data?.id ?? -1}

      updateAddress(request);
    }
    if(singleItem.active) {}
  };
  const handleClickDelete = () => {
    // console.log("delete " + singleItem.complete_address);
    setOpenConfirmDialog(true);
  };
  const handleClickEdit = () => {
    // console.log("delete " + singleItem.complete_address);
    setOpenEditAddressDialog(true);
  };
  const handleConfirmDialog = () => {
    setOpenConfirmDialog(!openConfirmDialog);
  };
  const handleConfirmCloseEdit = () => {
    setOpenEditAddressDialog(!openEditAddressDialog);
  };
  return (
    <>
      <DeleteAddressConfirmDialog
        open={openConfirmDialog}
        address={singleItem}
        handleCloseDialog={handleConfirmDialog}
        shoppingBagQuery={shoppingBagQuery}
      />
      <EditAddressDialog
        open={openEditAddressDialog}
        address={singleItem}
        handleClose={handleConfirmCloseEdit}
        shoppingBagQuery={shoppingBagQuery}
      />
      <Card
        variant="outlined"
        sx={{
          marginTop: "10px",
          border: singleItem.active
            ? "1px solid rgba(251,107,28, 0.8)"
            : "1px solid rgba(0, 0, 0, 0.12)",
        }}
      >
        <CardContent>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              fontSize="0.7rem"
              color={Colors.baseTextColor}
              fontWeight="300"
            >
              Endereço #
            </Typography>
            <Typography
              fontSize="0.7rem"
              color={Colors.grayTextColorDarkestDark}
              fontWeight="700"
            >
              {singleItem.id}
            </Typography>
            <Box sx={{ flexGrow: 1 }} />
            <IconButton
              size="small"
              color="default"
              onClick={handleClickEdit}
            >
              <Edit
                sx={{
                  width: "20px",
                  height: "20px",
                }}
              />
            </IconButton>
            <IconButton
              size="small"
              color="default"
              onClick={handleClickDelete}
            >
              <Delete
                sx={{
                  width: "20px",
                  height: "20px",
                }}
              />
            </IconButton>
          </Box>
          <Divider sx={{ padding: "5px" }} />

          <Box
            display={"flex"}
            sx={{
              flexGrow: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                alignContent: "center",
              }}
            >
              {singleItem.type === "H" && (
                <House color={singleItem.active ? "primary" : "action"} />
              )}
              {singleItem.type === "O" && (
                <Business color={singleItem.active ? "primary" : "action"} />
              )}
            </Box>
            <Box p={1} marginLeft={"10px"}>
              <Box>
                <Typography
                  fontSize="12px"
                  fontWeight={"400"}
                  color={Colors.grayTextColorDarkestDark}
                >
                  {singleItem.type === "H" && "Casa"}
                  {singleItem.type === "O" && "Trabalho"}
                </Typography>
              </Box>
              <Typography
                fontSize="12px"
                fontWeight={"700"}
                color={Colors.grayTextColorDarkestDark}
              >
                {singleItem.complete_address}
              </Typography>
              <Typography fontSize="10px" color={Colors.baseTextColor}>
                {singleItem.reference_point}
              </Typography>
            </Box>
            <Box flexGrow="1" />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <Radio
                size="medium"
                checked={singleItem.active}
                onClick={handleClickUpdate}
              />
            </Box>
          </Box>
        </CardContent>
        <CardActions></CardActions>
      </Card>
    </>
  );
}

export default SingleAddressCard;
